import React, { useState } from "react";
import Layout from "../../components/Layout/Layout";
import { Link } from "react-router-dom";
import styles from "./DropLocation.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  saveDropoffLocation,
} from "../../redux/actions/orderActions";
import Map from './../../components/Map/index'
import { Row, Col } from "reactstrap";

const DropLocation = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  const dispatch = useDispatch();

  const [dropoffNumber, setDropoffNumber] = useState("");
  const [dropoffName, setDropoffName] = useState("");
  const [landmark, setLandmark] = useState("");
  const [dropoffLocation, setDropoffLocation] = React.useState({
    meetingPoint: "",
    address: '',
    city: '',
    area: '',
    state: '',
    country: '',
    mapPosition: {
      lat: 0,
      lng: 0
    },
    markerPosition: {
      lat: 0,
      lng: 0
    },
  });

  const today = new Date();
  const date =
    today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
  const time =
    today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();

  const dropoffInfo = {
    dropoffLocation: landmark,
    dropoffNumber: dropoffNumber,
    dropoffName: dropoffName,
    Landmark: landmark,
    time: time,
    date: date,
    address: {
      address: landmark,
      coordinates: {
        lat: dropoffLocation?.mapPosition?.lat,
        long: dropoffLocation?.mapPosition?.lng,
      },
    },
  };

  const dropLocationObj = useSelector(state => state?.saveDropoff?.dropoffInfo ? state?.saveDropoff?.dropoffInfo : {})

  const saveDropoff = () => {
    dispatch(saveDropoffLocation(dropoffInfo));
  };


  return (
    <Layout title="Drop Location" route={"/pickup-location"}>
      <div className="content map" style={{ marginTop: '101px' }}>
        <Row>
          <Map
            setState={setDropoffLocation}
            state={dropoffLocation}
            setLandmark={setLandmark}
            setNumber={setDropoffNumber}
            setName={setDropoffName}
            fillUpData={{
              ...dropLocationObj,
              userName: dropLocationObj?.dropoffName,
              number: dropLocationObj?.dropoffNumber,

            }}
            style={{
              boxSizing: 'border-box',
              border: '2px solid #ccc',
              borderRadius: '4px',
              fontSize: '16px',
              backgroundColor: 'white',
              backgroundImage: `url('search.svg')`,
              backgroundPosition: '6px 8px',
              backgroundSize: '24px',
              backgroundRepeat: 'no-repeat',
              padding: '12px 20px 12px 40px',
              width: '50%',
              height: '42px',
              position: 'absolute',
              top: '110px',
              left: '60px',
            }}
          />
          <Col>
            {true ? (
              <div className={styles.detailContainer}>
                <div className={styles.input_2}>
                  <i className={styles.icon + " fas fa-arrow-circle-up"}></i>
                  <input
                    type="text"
                    value={landmark}
                    onChange={(e) => setLandmark(e.target.value)}
                    name="place"
                    placeholder="Enter Landmark"
                  />
                </div>
                <div className={styles.input_2}>
                  <i className={styles.icon + " fas fa-user"}></i>
                  <input
                    type="text"
                    value={dropoffName}
                    onChange={(e) => setDropoffName(e.target.value)}
                    name="location"
                    placeholder="Name of person"
                  />
                </div>
                <div className={styles.input_2}>
                  <i className={styles.icon + " fas fa-phone"}></i>
                  <input
                    type="text"
                    value={dropoffNumber}
                    onChange={(e) => setDropoffNumber(e.target.value)}
                    name="location"
                    placeholder="Contact Number"
                  />
                </div>
                <Link to="/courier-info">
                  <button onClick={saveDropoff}>
                    Continue{" "}
                    <i className={styles.icon + " fas fa-long-arrow-alt-down"}></i>
                  </button>
                </Link>
              </div>
            ) : null}
          </Col>
        </Row>
      </div>
    </Layout>
  );
};

export default DropLocation;
